import {ApiCall} from "./core.js";

export class Login{

    constructor() {
        this.txtUsername = document.querySelector("#txtUsername");
        this.txtPassword = document.querySelector("#txtPass");
        this.btnLogin = document.querySelector("#btnLogin");

        this.btnLogin.addEventListener("click", this.onLogin.bind(this));

    }

    onLogin(e){
        e.preventDefault();
        console.log("LoginApiController precionado");

        let params = {
            user: this.txtUsername.value,
            pass: this.txtPassword.value
        }

        ApiCall.loadRemote("API/LoginApi/access", params).then( data => {

            localStorage.setItem("username", data.username);
            localStorage.setItem("name", data.name);
            localStorage.setItem("email", data.email);

            if(data.hasOwnProperty("vendor_id")) {
                localStorage.setItem("vendor_id", data.vendor_id);
                localStorage.setItem("warehouse_id", data.warehouse_id);
                localStorage.setItem("warehouse_name", data.warehouse_name);
            }
            window.location= 'Home';


        }).catch(reason => {
            console.log(reason);
            this.txtPassword.focus();
        });
    }
}

new Login();